import React, { forwardRef, useMemo } from "react"
import { useTranslation } from "react-i18next"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { getFlatpickrLocale } from "utils/datePickerLocale"

/**
 * Flatpickr wrapper that switches month/weekday labels to Arabic
 * when the portal language is Arabic (`sa`).
 */
const LocalizedFlatpickr = forwardRef(function LocalizedFlatpickr(
  { options = {}, ...rest },
  ref
) {
  const {
    i18n: { language },
  } = useTranslation()

  const locale = getFlatpickrLocale(language)
  const mergedOptions = useMemo(
    () => ({
      ...options,
      ...(locale ? { locale } : {}),
    }),
    [options, locale]
  )

  // Remount when language changes so an open calendar refreshes labels.
  return (
    <Flatpickr
      key={language}
      ref={ref}
      options={mergedOptions}
      {...rest}
    />
  )
})

export default LocalizedFlatpickr
